export const DEFAULT_CACHE_CONFIG = {
  cacheTime: 1000 * 60 * 60 * 8, // 8 hours
  staleTime: 1000 * 60 * 60 * 8, // 8 hours
  retry: 1
};
